import LogoArchitect from './LogoArchitect'

export default LogoArchitect
// eslint-disable-next-line import/export
export * from './LogoArchitect'
